@use '~/theme/theme' as *;

.builderSection {
  display: flex;
  flex-direction: column;
  gap: spacing(2);
}
